import { LOC_FORM, LOC_FORM_OPENING, LOC_REPORT_NAME } from "../../locKeys";
import { Action } from "./Action";

export class OpenForm extends Action {
    public formType: FormType;
    public formClass: string;
    public reportName: string;
    public masterLinkToAttr: string;
    public formCondition: string;

    constructor(formType: string, formClass: string, reportName: string, masterLinkToAttr: string, formCondition: string, condition: string, comment: string) {
        super(condition, comment);

        this.formType = OpenForm.getFormType(formType);
        this.formClass = this.formType !== FormType.report ? formClass : "";
        this.reportName = this.formType === FormType.report ? reportName : "";
        this.masterLinkToAttr = this.formType !== FormType.report ? masterLinkToAttr : "";
        this.formCondition = this.formType !== FormType.report ? formCondition : "";
    }

    public override async validate(): Promise<void> {
        if (this.formType !== FormType.report) {
            if (!this.formClass)
                throw new Error(await this.getActionErrorMessage(LOC_FORM, LOC_FORM_OPENING));
        } else {
            if (!this.reportName)
                throw new Error(await this.getActionErrorMessage(LOC_REPORT_NAME, LOC_FORM_OPENING));
        }
    }

    private static getFormType(stringFormType: string): FormType {
        const type = (FormType as any)[stringFormType];

        if (type != null)
            return type;
        if (stringFormType === "-1")
            return FormType.report;
        if (stringFormType === "0")
            return FormType.form;
        if (stringFormType === "1")
            return FormType.printForm;
        if (stringFormType === "2")
            return FormType.actionForm;
        return FormType.form;
    }
}

export enum FormType {
    report = "report",
    form = "form",
    printForm = "printForm",
    actionForm = "actionForm",
}
